import { format, parse } from '@legacy/js/date/date-fns.js';

export default class BatchTeamMemberRelation {
    // `entity` is passed in rather than fixed: the action exists for ClubMember and ClubEmployee, and the
    // backend resolves it by the (entity, label) pair — the label alone is ambiguous.
    constructor(entity = 'ClubMember') {
        this.action = 'TeamAssignment';
        this.entity = entity;
        this.start = null;
        this.end = null;
    }

    serialize() {
        const start = parse(this.start, 'dd.MM.yyyy', new Date());
        const end = this.end === null ? null : parse(this.end, 'dd.MM.yyyy', new Date());
        return {
            action: this.action,
            entity: this.entity,
            ids: this.ids,
            teamId: this.team?.id,
            start: format(start, 'dd.MM.yyyy'),
            end: end === null ? null : format(end, 'dd.MM.yyyy'),
        };
    }

    isValid() {
        if (!this.team) {
            return false;
        }
        if (!this.start) {
            return false;
        }
        if (!this.ids || this.ids.length === 0) {
            return false;
        }
        return true;
    }
}
